'use client';

import { HStack } from '@terra/ui-styled-system';
import { LinkSquare02Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { Button } from '../../../../../components/button';
import { MetaDefault } from '../../../../../components/typography';
import type { OutputRenderContext } from '../../tool-config-types';

type ViewExecutionActionProps = {
  executionId: string;
  onOpenObject?: OutputRenderContext['onOpenObject'];
};

export function ViewExecutionAction({
  executionId,
  onOpenObject,
}: ViewExecutionActionProps) {
  const t = useTranslations('designSystem.chat.attackerTool');

  if (!onOpenObject) {
    return null;
  }

  return (
    <Button
      variant="ghost"
      size="xs"
      onClick={(event) => {
        event.stopPropagation();
        onOpenObject({
          type: 'execution',
          id: executionId,
          label: t('viewExecution'),
        });
      }}
    >
      <HStack gap={1} alignItems="center">
        <MetaDefault>{t('viewExecution')}</MetaDefault>
        <LinkSquare02Icon size={11} />
      </HStack>
    </Button>
  );
}
